import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddIcon from "@mui/icons-material/Add";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import TextFieldsOutlinedIcon from "@mui/icons-material/TextFieldsOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import "../components/knowledgebase/knowledge-base-editor.css";
import "../components/trainer/trainer-editor.css";
import "./landing-editor-screenshot.css";

function BrowserFrame({ title, children }) {
  return (
    <div className="landing-app-stage">
      <div className="landing-app-stage__head">
        <span className="landing-app-stage__badge">Личный кабинет MOGAME</span>
        <span className="landing-app-stage__hint">Интерфейс для HR — не эта страница</span>
      </div>
      <div className="landing-ui-shot">
        <div className="landing-ui-shot__chrome">
          <span className="landing-ui-shot__dots" aria-hidden="true">
            <i />
            <i />
            <i />
          </span>
          <span className="landing-ui-shot__title">{title}</span>
        </div>
        <div className="landing-ui-shot__body">{children}</div>
      </div>
    </div>
  );
}

export function KnowledgeBaseEditorShot() {
  return (
    <BrowserFrame title="club-lab.ru — База знаний">
      <div className="landing-ui-shot__app">
        <div className="trainer-editor kb-editor landing-ui-shot__editor">
          <div className="trainer-editor__toolbar trainer-editor__toolbar--tabs">
            <span className="app-editor__tab app-editor__tab--active">
              <EditOutlinedIcon fontSize="small" /> Редактор
            </span>
            <span className="app-editor__tab">
              <MenuBookOutlinedIcon fontSize="small" /> Настройки
            </span>
          </div>
          <div className="trainer-editor__meta-bar">
            <span className="trainer-editor__meta-theme">
              Тема: <strong>Монтаж на объекте</strong>
            </span>
            <span className="trainer-editor__meta-count">12 вопросов</span>
          </div>
          <div className="trainer-editor__workspace kb-editor__workspace">
            <section className="trainer-editor__card trainer-editor__card--questions">
              <div className="trainer-editor__card-head">
                <div>
                  <h3>Темы и вопросы</h3>
                </div>
                <div className="kb-editor__head-actions">
                  <span className="landing-ui-shot__btn">
                    <AddIcon fontSize="small" /> Тема
                  </span>
                  <span className="landing-ui-shot__btn">
                    <AddIcon fontSize="small" /> Подтема
                  </span>
                </div>
              </div>
              <div className="kb-editor__layout landing-ui-shot__kb-layout">
                <div className="kb-editor__topics-panel">
                  <ul className="kb-editor__topic-list">
                    <li>
                      <div className="kb-editor__topic-item kb-editor__topic-item--active">
                        <button type="button" className="kb-editor__topic-btn">
                          <FolderOutlinedIcon fontSize="small" />
                          Подключение оборудования
                        </button>
                      </div>
                    </li>
                    <li>
                      <div className="kb-editor__topic-item">
                        <button type="button" className="kb-editor__topic-btn">
                          <FolderOutlinedIcon fontSize="small" />
                          Безопасность на объекте
                        </button>
                      </div>
                    </li>
                    <li>
                      <div className="kb-editor__topic-item">
                        <button type="button" className="kb-editor__topic-btn">
                          <FolderOutlinedIcon fontSize="small" />
                          Документы и акты
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="kb-editor__content-panel">
                  <div className="landing-ui-shot__field">
                    <label>Вопрос</label>
                    <div className="landing-ui-shot__input">
                      Какой кабель использовать для блока питания?
                    </div>
                  </div>
                  <div className="landing-ui-shot__mode">
                    <span className="landing-ui-shot__mode-btn landing-ui-shot__mode-btn--active">
                      <TextFieldsOutlinedIcon fontSize="small" /> Текст
                    </span>
                    <span className="landing-ui-shot__mode-btn">
                      <VideocamOutlinedIcon fontSize="small" /> Видео
                    </span>
                  </div>
                  <div className="landing-ui-shot__field">
                    <label>Ответ</label>
                    <div className="landing-ui-shot__textarea">
                      Используйте кабель ВВГнг 3×2,5 мм². Проверьте маркировку на
                      бухте и заземление перед включением.
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </BrowserFrame>
  );
}

export function ScenarioEditorShot() {
  return (
    <BrowserFrame title="club-lab.ru — Сценарий">
      <div className="landing-ui-shot__app landing-ui-shot__app--scenario">
        <div className="trainer-editor__toolbar trainer-editor__toolbar--tabs">
          <span className="app-editor__tab app-editor__tab--active">
            <EditOutlinedIcon fontSize="small" /> Карта сцен
          </span>
          <span className="app-editor__tab">Настройки</span>
        </div>
        <div className="landing-ui-shot__scenario-canvas">
          <div className="landing-ui-shot__scenario-group">
            <div className="landing-ui-shot__scenario-group-label">
              Сцена 1 · Приветствие
              <span className="landing-ui-shot__scenario-type">Текст</span>
            </div>
            <div className="landing-ui-shot__scenario-scene landing-ui-shot__scenario-scene--text">
              <p className="landing-ui-shot__scenario-text">
                Добро пожаловать в программу адаптации! Сегодня вы познакомитесь
                с командой, рабочими процессами и правилами сервиса. Прочитайте
                материал и выберите, что делать дальше.
              </p>
            </div>
            <div className="landing-ui-shot__scenario-buttons">
              <span>Дальше по регламенту</span>
              <span>Задать вопрос HR</span>
            </div>
          </div>
          <div className="landing-ui-shot__scenario-arrow" />
          <div className="landing-ui-shot__scenario-group landing-ui-shot__scenario-group--alt">
            <div className="landing-ui-shot__scenario-group-label">
              Сцена 2 · Касса
              <span className="landing-ui-shot__scenario-type landing-ui-shot__scenario-type--video">
                Видео
              </span>
            </div>
            <div className="landing-ui-shot__scenario-scene">
              <div className="landing-ui-shot__scenario-video">
                <span className="landing-ui-shot__scenario-play" aria-hidden="true">
                  <PlayArrowRoundedIcon />
                </span>
              </div>
              <p>Клиент просит возврат без чека</p>
            </div>
            <div className="landing-ui-shot__scenario-buttons">
              <span>Предложить обмен</span>
              <span>Вызвать старшего</span>
            </div>
          </div>
        </div>
      </div>
    </BrowserFrame>
  );
}

export function TrainerEditorShot() {
  return (
    <BrowserFrame title="club-lab.ru — Тренажёр">
      <div className="landing-ui-shot__app">
        <div className="trainer-editor landing-ui-shot__editor">
          <div className="trainer-editor__toolbar trainer-editor__toolbar--tabs">
            <span className="app-editor__tab app-editor__tab--active">
              <EditOutlinedIcon fontSize="small" /> Вопросы
            </span>
            <span className="app-editor__tab">Настройки</span>
          </div>
          <div className="trainer-editor__meta-bar">
            <span className="trainer-editor__meta-theme">
              Тема: <strong>Продуктовые знания</strong>
            </span>
            <span className="trainer-editor__meta-count">8 вопросов</span>
          </div>
          <div className="trainer-editor__workspace">
            <section className="trainer-editor__card trainer-editor__card--questions landing-ui-shot__trainer-card">
              <div className="trainer-editor__questions-layout landing-ui-shot__trainer-layout">
                <div className="trainer-editor__questions-nav">
                  <button type="button" className="landing-ui-shot__q-item landing-ui-shot__q-item--active">
                    1. Какой тариф подходит новому клиенту?
                  </button>
                  <button type="button" className="landing-ui-shot__q-item">
                    2. Что делать при возражении «дорого»?
                  </button>
                  <button type="button" className="landing-ui-shot__q-item">
                    3. Как оформить пробный доступ?
                  </button>
                </div>
                <div className="trainer-editor__questions-editor landing-ui-shot__trainer-detail">
                  <div className="landing-ui-shot__field">
                    <label>Вопрос</label>
                    <div className="landing-ui-shot__input">
                      Какой тариф подходит новому клиенту?
                    </div>
                  </div>
                  <div className="landing-ui-shot__answers">
                    <label className="landing-ui-shot__answer landing-ui-shot__answer--ok">
                      <CheckCircleOutlineIcon fontSize="small" /> Базовый — до 15 сотрудников
                    </label>
                    <label className="landing-ui-shot__answer">Расширенный</label>
                    <label className="landing-ui-shot__answer">Корпоративный</label>
                  </div>
                  <span className="landing-ui-shot__btn landing-ui-shot__btn--ghost">
                    <AddIcon fontSize="small" /> Добавить ответ
                  </span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </BrowserFrame>
  );
}

const SHOTS = {
  knowledge_base: KnowledgeBaseEditorShot,
  scenario: ScenarioEditorShot,
  trainer: TrainerEditorShot,
};

export default function LandingEditorScreenshot({ type }) {
  const Shot = SHOTS[type] ?? KnowledgeBaseEditorShot;
  return <Shot />;
}
